// オブジェクトを取得
//-------------------------------------------------
// タグを取得
const modalNavWrap = document.getElementById("es--inner--accordion");
// // インナーヘッダーのスパンタグを取得（＋アニメ用）
// const innerHeaderSpan = document.getElementById("es--inner--accordion--span");

// // クリックでクラスをトグル（メニュー開閉）
// //-------------------------------------------------
// // ハンバーガーメニューのアクティブクラスを付与する関数
const navButtonToggle = e => {
    if (window.innerWidth <= 959) {
        // タグ名を取得しておく
        let clickTagName = e.target.id;

        // ボタンは常時動作・背景はオープン時のみ駆動
        console.log(clickTagName);
        if (clickTagName === "es--inner--accordion--span") {
            // SPボタンに指定クラスがあるか確認
            if (innerHeaderSpan.classList.contains("inner--active")) {
                // あればメニューモードなのでそれぞれのクラスを除外後、スクロールリスナーを外す
                modalNavWrap.classList.remove("inner--open");
                innerHeaderSpan.classList.remove("inner--active");
            } else {
                // なければメニューモードに移行処理、スクロールリスナーを付ける
                modalNavWrap.classList.add("inner--open");
                innerHeaderSpan.classList.add("inner--active");
            }
        }
    }
};

// // エージェントによるイベント登録分岐
// //-------------------------------------------------
// if (typeof window !== `undefined`) {
//   // エージェントの時はこっち
//   if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
//     innerHeaderSpan.addEventListener("touchend", navButtonToggle);
//   } else {
//     innerHeaderSpan.addEventListener("mouseup", navButtonToggle);
//   }
// }

//--------------------

// メニュー項目内のspanタグを全て取得
const menuItemSpans = document.querySelectorAll(".menu--item span");

// spanタグのクリックイベントに対する関数
const toggleMenuItem = e => {
    if (window.innerWidth <= 959) {
        // クリックされたspanタグの親要素（メニュー項目）を取得
        const menuItem = e.currentTarget.parentElement;

        // メニュー項目にアクティブクラスがあるか確認
        if (menuItem.classList.contains("inner--active")) {
            // アクティブクラスがあれば、クラスを除外
            menuItem.classList.remove("inner--active");
        } else {
            // アクティブクラスがなければ、クラスを追加
            menuItem.classList.add("inner--active");
        }
    }
};

let toggleCheck = {};
function ck(e, click_or_touch,after_function){//この関数を使って問題を解決する
    if(toggleCheck.status){//データがある時
        if(toggleCheck.status == click_or_touch){//1000ms前の入力方法と同じ
            after_function(e);//処理を実行する
        }
    }else{//データが無い時
        toggleCheck.status = click_or_touch;//入力方法を記録
        setTimeout(function(){
            delete toggleCheck.status;//データを削除する
        },1000/*データが削除されるまでの時間(ms)*/);
        after_function(e);//処理を実行する
    }
}

// 各spanタグにクリックイベントリスナーを設定
menuItemSpans.forEach(span => span.addEventListener("mouseup", e => {
    ck(e, "mouse",toggleMenuItem)
}));
menuItemSpans.forEach(span => span.addEventListener("touchend", e => {
    ck(e, "touch", toggleMenuItem)
}));

//# sourceURL=webpack://lp_create_kit/./src/js/inner_navigation.js?